export namespace NAccountDelete {
    export const componentId = 'account-delete';

    export interface IDeleteContent {
        title?: string;
        copy?: string; // rich text supported
    }
}

